'use strict';

var status = require('../../../../../../../../../../_virtual/status.cjs');

var hasRequiredStatus;

function requireStatus () {
	if (hasRequiredStatus) return status.__exports;
	hasRequiredStatus = 1;

	var STATUS_INTENTIONS = /*#__PURE__*/ function(STATUS_INTENTIONS) {
	    STATUS_INTENTIONS["critical"] = "critical";
	    STATUS_INTENTIONS["info"] = "info";
	    STATUS_INTENTIONS["neutral"] = "neutral";
	    STATUS_INTENTIONS["success"] = "success";
	    STATUS_INTENTIONS["warning"] = "warning";
	    return STATUS_INTENTIONS;
	}({});

	status.__exports.STATUS_INTENTIONS = STATUS_INTENTIONS;
	
	return status.__exports;
}

exports.__require = requireStatus;
//# sourceMappingURL=status.cjs.map
